import { Text, Input } from '@components/primitives';
import { getStore } from '@store/storeUtils';
import colors from '@theme/colors';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import React, { useState } from 'react';
import {
  getBackgroundColor,
  getBorderColorForInput,
  getDisabledColorForText,
  shouldGetCloseIcon,
  shouldShowError,
} from './loginPhoneInputUtils';

const phoneEvent = AMPLITUDE_CONSTANTS.authentication;

function LoginPhoneInput(props: {
  phoneNumber?: string;
  setPhoneNumber?: (val: string) => void;
  placeholderText?: string;
  sError?: string;
  isDisabled?: boolean;
  isEditable?: boolean;
  logParams?: Record<string, any>;
  onPropsFocus?: () => void;
  onPropsBlur?: () => void;
}) {
  const {
    phoneNumber = '',
    setPhoneNumber = () => {},
    placeholderText,
    sError = '',
    isDisabled = false,
    isEditable = true,
    logParams = {},
    onPropsFocus = null,
    onPropsBlur = null,
  } = props;

  const { tenantSettings } = getStore();
  const { countryCode } = tenantSettings;
  const [isFocused, setIsFocused] = useState(false);

  const onFocusHandler = () => {
    setIsFocused(true);
    if (onPropsFocus) return onPropsFocus();
    AmplitudeHelper.logEvent(phoneEvent.phone_number_clicked.name, logParams, true);
  };

  const onEndEditingHandler = () => {
    if (onPropsBlur) return onPropsBlur();
    AmplitudeHelper.logEvent(phoneEvent.phone_number_filled.name, logParams, true);
  };

  return (
    <>
      <Input
        testID="loginPhoneInput"
        backgroundColor={getBackgroundColor(isDisabled)}
        isDisabled={isDisabled}
        editable={isEditable}
        marginTop={4}
        borderWidth={1}
        variant="unstyled"
        _focus={{
          borderColor: getBorderColorForInput(sError, isFocused),
        }}
        InputLeftElement={
          <Text testID="txtCountryCode" color={getDisabledColorForText(isDisabled)} variant="md-bold">
            +{countryCode}
          </Text>
        }
        color={colors.neutral.charcoal} // Fixed: Use charcoal color for text
        fontFamily="Nunito-Regular" // Set Nunito font
        InputRightElement={shouldGetCloseIcon(isDisabled, phoneNumber, setPhoneNumber)}
        placeholder={placeholderText || '8123456789'}
        size="md"
        fontWeight="100"
        value={phoneNumber}
        keyboardType="number-pad"
        onFocus={onFocusHandler}
        onBlur={onEndEditingHandler}
        onChangeText={(val: string) => setPhoneNumber(val)}
        {...props}
      />
      {shouldShowError(sError)}
    </>
  );
}

LoginPhoneInput.defaultProps = {
  phoneNumber: '',
  sError: '',
  isDisabled: false,
  isEditable: true,
  setPhoneNumber: () => {},
  logParams: {},
  onPropsFocus: null,
  onPropsBlur: null,
};

export default LoginPhoneInput;
